import React from "react";
import { useHistory } from "react-router-dom";
import ListEmptyView from "./ListEmptyView";

export interface RbacAccessDeniedProps {
  title?: string;
  description?: string;
  backPath?: string;
  backLabel?: string;
}

export default function RbacAccessDenied({
  title = "You don't have access to this page",
  description = "Your account doesn't include the required permission. Contact an administrator if you think this is a mistake.",
  backPath = "/search",
  backLabel = "Go to Dashboard",
}: RbacAccessDeniedProps) {
  const history = useHistory();
  return (
    <ListEmptyView
      title={title}
      description={description}
      primaryAction={{
        label: backLabel,
        onClick: () => history.push(backPath),
      }}
    />
  );
}
